<template>
    <!-- Main Content Start -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Weekly Salary Slip Report</h2>
        </div>
        
        <div class="card p-4 mb-4">
            <form @submit.prevent="filterSalarySlip">
                <!-- Filter Form -->
                <div class="flex flex-col md:flex-row md:items-center md:space-x-4 space-y-4 md:space-y-0">
                    <!-- From Date -->
                    <div class="w-full md:w-auto mt-4">
                        <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
                        <input type="date" id="startDate" v-model="startDate" class="w-full md:w-auto p-2 border border-gray-300 rounded" />
                    </div>
                    <!-- To Date -->
                    <div class="w-full md:w-auto ml-2">
                        <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
                        <input type="date" id="endDate" v-model="endDate" class="w-full md:w-auto p-2 border border-gray-300 rounded" />
                    </div>
                    <!-- Filter Button -->
                    <div class="w-full md:w-auto ml-2">
                        <button type="submit" class="btn b-solid btn-primary-solid px-5 w-full md:w-auto mt-4 md:mt-6 ml-0 md:ml-2 cursor-pointer">Filter</button>
                    </div>
                </div>
            </form>
        </div>

        <div class="w-full lg:w-auto lg:ml-2 mt-4 mb-2 ml-2">
            <button @click="exportToExcel" class="w-full lg:w-auto btn btn-primary-solid px-5 mt-2 lg:mt-6 cursor-pointer">
                Export
            </button>
        </div>
        
        <div class="printonly">
            From {{startDate}} To {{endDate}}
        </div>

        
        <div class="card">
            <!-- Static heading -->
            <div id="printable-content">
                <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>
                <h1 class="print-only" style="text-align: center;">Weekly Salary Slip Report</h1>
            </div>

            <button
                type="reset"
                @click="printReceipt"
                class="btn b-light btn-danger-light btn-sm"
            >
                Print
            </button>
            </div>


        
        <!-- Table Content -->
        <div class="grid grid-cols-12">
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th>Entry Date</th>
                                    <th>Parent Name</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Over Time</th>
                                    <th>Total Male</th>
                                    <th>Male Amount</th> 
                                    <th>Total Female</th> 
                                    <th>Female Amount</th> 
                                    <th>Gadi Bhade</th> 
                                    <th>Gadi Rate</th> 
                                    <th>Gadi Amount</th> 
                                    <th>Amount</th> 
                                    <th>Status</th> 
                                    <th>Action</th> 
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item, index) in filteredsalslipList" :key="item.id">
                                    <td>{{ item.entrydate }}</td>
                                    <!-- Parent Name with click event to filter -->
                                    <td @click="filterByParentName(item.parent_name)" class="cursor-pointer">{{ item.parent_name }}</td>
                                    <td>{{ item.from_date }}</td>
                                    <td>{{ item.to_date }}</td>
                                    <td>{{ item.overtime }}</td>
                                    <td>{{ item.total_male }}</td>
                                    <td>{{ item.male_amt }}</td> 
                                    <td>{{ item.total_female }}</td>
                                    <td>{{ item.female_amt }}</td> 
                                    <td>{{ item.gadi_bhade }}</td> 
                                    <td>{{ item.gadi_rate }}</td> 
                                    <td>{{ calculateAmount(item.gadi_bhade, item.gadi_rate) }}</td>
                                    <td>{{ item.amount }}</td> 
                                    <td>{{ item.status_label }}</td> 
                                    <td @click="getSalarySlipDetails(item.id)">View</td>                                  
                                </tr> 
                            </tbody>
                            <!-- Table Footer for Totals -->
                            <tfoot>
                                <tr>
                                    <td colspan="4" class="text-right font-semibold">Total:</td>
                                    <td>{{ overtime }}</td>
                                    <td>{{ totalMale }}</td>
                                    <td>{{ totalMaleAmount }}</td>
                                    <td>{{ totalFemale }}</td>
                                    <td>{{ totalFemaleAmount }}</td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ totalGadiAmount }}</td>
                                    <td>{{ totalAmount }}</td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Main Content End -->
</template>

<script>
import axios from 'axios';

export default {
    name: 'salarySlipReport',
    data() {
        const today = new Date().toISOString().split('T')[0];
        return {
            salslipList: [],
            filteredsalslipList: [],
            datatable: null,
            startDate: new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
            endDate: today,
            totalMale: 0,
            totalMaleAmount: 0,
            totalFemale: 0,
            totalFemaleAmount: 0,
            totalGadiAmount: 0,
            totalAmount: 0,
        };
    },
    mounted() {
        this.getBasics();
    },
    watch: {
        filteredsalslipList() {
            this.$nextTick(() => {
                $('.datatable').DataTable().draw();
                this.calculateTotals();
            });
        },
    },
    methods: {
        getSalarySlipDetails(id) {
            window.open('/salaryslipdetails?q=' + id, '_blank');
        },
        exportToExcel() {
        // Prepare the CSV header
        const headers = ["entrydate", "parent_name", "from_date", "to_date", "total_male", "total_female", "female_amt", "gadi_bhade", "gadi_rate", "amount", "status_label"];
        const rows = this.filteredsalslipList.map(item => [
        this.formatDate(item.entrydate),
            item.parent_name,
            this.formatDate(item.from_date),
            this.formatDate(item.to_date),
            item.total_male,
            item.male_amt,
            item.total_female,
            item.female_amt,
            item.gadi_bhade,
            item.gadi_rate,
            item.amount,
            item.status_label,
        ]);

        // Combine headers and rows into a CSV string
        const csvContent = [headers, ...rows]
            .map(row => row.map(value => `"${value}"`).join(","))
            .join("\n");

        // Create a Blob from the CSV content
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        // Trigger a download
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "salaryslipreport.csv");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    // Helper function to format the date
    formatDate(date) {
            if (!date) return "";  // Return empty string if date is missing
            const d = new Date(date);
            return d.toLocaleDateString();  // You can format this as per your requirement
        },
        calculateAmount(bhade, rate) {
            return (bhade * rate).toFixed(2);
        },
        async getBasics() {
            const self = this;
            axios.post('getSalSlipReport').then(function (response) {
                self.salslipList = response.data.salslipList;
                self.filteredsalslipList = response.data.salslipList;
            }).then(() => {
                self.datatable = $(".datatable").DataTable({
                    paging: true,
                    ordering: true,
                    autoWidth: false
                });
            });
        },
        filterSalarySlip() {
            if (this.datatable) {
                this.datatable.destroy();
            }

            let filteredList = this.salslipList;
            if (this.startDate) {
                filteredList = filteredList.filter(item => new Date(item.entrydate) >= new Date(this.startDate));
            }

            if (this.endDate) {
                filteredList = filteredList.filter(item => new Date(item.entrydate) <= new Date(this.endDate));
            }

            this.filteredsalslipList = filteredList;

            this.$nextTick(() => {
                this.datatable = $(".datatable").DataTable({
                    paging: true,
                    ordering: true,
                    autoWidth: false
                });
            });
        },


        printReceipt() {
            $('.datatable').DataTable().destroy(); 
             window.print();
    },




        filterByParentName(parentName) {
            if (this.datatable) {
                this.datatable.destroy();
            }

            this.filteredsalslipList = this.salslipList.filter(item => item.parent_name === parentName);

            this.$nextTick(() => {
                this.datatable = $(".datatable").DataTable({
                    paging: true,
                    ordering: true,
                    autoWidth: false
                });
            });

            this.calculateTotals();
        },
        calculateTotals() {
            this.overtime = this.filteredsalslipList.reduce((sum, item) => sum + Number(item.overtime), 0);
            this.totalMale = this.filteredsalslipList.reduce((sum, item) => sum + Number(item.total_male), 0);
            this.totalMaleAmount = this.filteredsalslipList.reduce((sum, item) => sum + Number(item.male_amt), 0).toFixed(2);
            this.totalFemale = this.filteredsalslipList.reduce((sum, item) => sum + Number(item.total_female), 0);
            this.totalFemaleAmount = this.filteredsalslipList.reduce((sum, item) => sum + Number(item.female_amt), 0).toFixed(2);
            this.totalGadiAmount = this.filteredsalslipList.reduce((sum, item) => sum + Number(this.calculateAmount(item.gadi_bhade, item.gadi_rate)), 0).toFixed(2);
            this.totalAmount = this.filteredsalslipList.reduce((sum, item) => sum + Number(item.amount), 0).toFixed(2);
        }
    }
}
</script>

<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    .printonly{
        display: none; 
    }
    
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
        .printonly{
        display: block; 
    }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    </style>
    










<style>



@media print {
    button, select, input, h2, .header_class, .header, .card-title,select,label,.select2 {
        display: none !important;
    }
    

}

    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}
</style>